import { Box, Flex, HStack, Stack, Text } from '@chakra-ui/react';
import { removeAuthToken } from 'api/helpers';
import Brand from 'components/sidebar/components/Brand';
import Links from 'components/sidebar/components/Links';
import { SIGN_OUT } from 'routes';

function SidebarContent(props: { routes: RoutesType[] }) {
    const { routes } = props;

    const handleClick = () => {
        removeAuthToken();
        window.location = SIGN_OUT.fullPath as unknown as Location;
    };

    return (
        <Flex direction="column" height="100%">
            <Brand />
            <Stack direction="column" mt="8px" mb="auto">
                <Box paddingX="12px" className="sidebar-menu">
                    <Links routes={routes} />
                    <Box
                        borderTop="1px"
                        borderColor="gray.100"
                        marginX="-12px"
                        paddingX="12px"
                        marginTop="8px"
                        paddingTop="8px"
                    >
                        <HStack
                            onClick={handleClick}
                            width="100%"
                            as="button"
                            borderRadius="8px"
                            spacing="26px"
                            py="5px"
                            ps="10px"
                            backgroundColor="transparent"
                        >
                            <Flex w="100%" alignItems="center" justifyContent="center" height="38px">
                                <Flex color="gray.500" mr="12px">
                                    {SIGN_OUT.icon}
                                </Flex>
                                <Text fontSize="md" me="auto" color="gray.500" fontWeight="normal">
                                    {SIGN_OUT.name}
                                </Text>
                            </Flex>
                        </HStack>
                    </Box>
                </Box>
            </Stack>

            {/* <Box ps="20px" pe={{ lg: '16px', '2xl': '20px' }} mt="60px" mb="40px" borderRadius="30px">
                <SidebarCard />
            </Box> */}
        </Flex>
    );
}

export default SidebarContent;
